import { Navigate } from 'react-router-dom';

export const OpsLanding = ({ isAdmin }: { isAdmin: boolean }) => {
  if (isAdmin) {
    return <Navigate to="dash" replace />;
  }

  // If the user is not an Admin, navigate to /ops/jobs
  return <Navigate to="jobs" replace />;
};

export default OpsLanding;
